import { cSolicitante } from "../../modelos/solicitante.modelo";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Renderer2 } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import * as myGlobals from "../../modelos/globales.modelo";
import * as DepartamentoArea from "../../modelos/dtoarea.modelo";
import * as Tramites from "../../modelos/tramite.modelo";
import * as FechasLibresArea from "../../modelos/fechahoraslibres.modelo";
import * as Solicitante from "../../modelos/solicitante.modelo";
import * as Cita from "../../modelos/cita.modelo";
import { MatStepper } from "@angular/material/stepper";
import { ApiAppService } from "../../servicios/apiapp.service";
import { atmConnectService } from "app/servicios/atmConnect.service";
import { Observable } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { environment } from "@environments/environment";

// Declaramos las variables para jQuery
declare let jquery: any;
declare let $: any;
declare let addeventatc: any;

// Interfaz donde vamos a almacenar los años y meses que se pueden dar cita
export interface IAnnioMesCita {
  ANNIO: number;
  MES: number;
}

export interface ICitaTemporal {
  id_area: number
  id_tramite: number;
}

// Clase donde se carga la información que se muestra abreviada
class cCitaAbreviada {
  area = "";
  fecha = "";
  hora = "";
  tramite = "";
}

@Component({
    selector: "app-pedir-cita",
    templateUrl: "pedircita.component.html",
    styleUrls: ["pedircita.component.css"],
    standalone: false
})
export class PedirCitaComponent implements OnInit {
  // Propiedades del control stepper

  public isLinear = true;
  public isEditable = false;

  public aDtosAreas: DepartamentoArea.IDtoArea[];
  public aPersonaArea: DepartamentoArea.IPersonaArea[];
  public aTramitesArea: Tramites.cTramite[];

  public oAreaActiva: DepartamentoArea.IDtoArea;
  public oTramiteActivo: Tramites.cTramite;
  public oPersonaAreaActiva: DepartamentoArea.IPersonaArea;
  public oFechaCitaAreaActiva: FechasLibresArea.IFechaHorasLibres;
  public aFechasCitaArea: FechasLibresArea.IFechaHorasLibres[];
  public aFechasCitaDisponibles: number[] = [];
  public iIndiceHorarioActivo: number;
  public oPrecitaBloqueo: Cita.IPrecitaBloqueo;
  public oSolicitante: Solicitante.cSolicitante;
  public videollamadaClienteEnabled: boolean = JSON.parse(
    myGlobals.getLocalStore(myGlobals.eLocalStore.ATM_CONNECT),
  );
  public videollamada: boolean;
  public sEnRepresentacionDe: string;
  public oRepresentado: Solicitante.cSolicitante;
  public iIndiceRepresentado: number;
  public sFiltroRepresentadoNIF: string;

  public sInfoArea: string;
  public sInfoAreaCarencia: string;
  public hayRepresentado: boolean;
  public representadook: boolean;

  public aAnnioMesCita: IAnnioMesCita[];
  public aCalendario: string[][];

  public iMesActivoCalendario: number;
  public iAnnioActivoCalendario: number;
  public iIndiceAnnioMesActivo: number;
  public iDiaActivoCalendario: number;
  public iFechaMaximaCita: number;
  public HayCitasLibresArea: boolean;

  public oDetalleCita: Cita.cDetalleCita;
  public AceptaLosTerminos: boolean;
  public isConfirming = false;
  public CitaConfirmada: boolean;

  public emailsolvalido: boolean;
  public emailrepvalido: boolean;
  public oCitaAbreviada: cCitaAbreviada;
  public citatemporal: ICitaTemporal;
  public sTipoNIFsol = "N";
  public sTipoNIFrep = "N";
  public sAvisoErrorNIFSol = "";
  public sAvisoErrorNIFRep = "";
  public sAvisoErrorNIFRepBusqueda = "";
  public sErrorNifIguales = "";

  public oCitaCalendario: Cita.cCitaCalendario;

  @ViewChild("stepper") oStepper: MatStepper;
  @ViewChild("frmSolicitante") myFormSolicitante: NgForm;
  @ViewChild("frmRepresentado") myFormRepresentado: NgForm;

  constructor(
    public oRouter: Router,
    public _ApiAppService: ApiAppService,
    public _AtmConnectService: atmConnectService,
    private renderer: Renderer2,
  ) {
    this.oAreaActiva = null;
    this.oPersonaAreaActiva = null;
    this.oTramiteActivo = null;
    this.oFechaCitaAreaActiva = null;
    this.iIndiceHorarioActivo = -1;
    this.sInfoArea = "";
    this.sInfoAreaCarencia = "";
    this.oSolicitante = new Solicitante.cSolicitante();
    this.oRepresentado = new Solicitante.cSolicitante();
    this.iIndiceRepresentado = 0;
    this.sFiltroRepresentadoNIF = "";
    this.hayRepresentado = false;
    this.representadook = false;
    this.iMesActivoCalendario = 0;
    this.iAnnioActivoCalendario = 0;
    this.iDiaActivoCalendario = 0;
    this.iIndiceAnnioMesActivo = 0;
    this.iFechaMaximaCita = 0;
    this.oDetalleCita = new Cita.cDetalleCita();
    this.AceptaLosTerminos = false;
    this.CitaConfirmada = false;
    this.emailsolvalido = true;
    this.emailrepvalido = true;
    this.oCitaAbreviada = new cCitaAbreviada();
    this.citatemporal = null;
    this.HayCitasLibresArea = false;
    this.oPrecitaBloqueo = null;
    this.sTipoNIFsol = "N";
    this.sTipoNIFrep = "N";
    this.sAvisoErrorNIFRepBusqueda = "";
    this.sEnRepresentacionDe = "";
  }

  ngOnInit() {
    $(".capa-cita").addClass("visible");

    // Comprobamos si la llamada se está realizando desde otro módulo de la aplicación
    // y nos están indicando el área y trámite a realizar

    const sCitaTmp = myGlobals.getSessionStore(
      myGlobals.eSessionStore.citatemporal,
    );

    if (myGlobals.isNullUndefinedVacio(sCitaTmp)) {
      this.citatemporal = { id_area: 0, id_tramite: 0 };
    } else {
      this.citatemporal = JSON.parse(sCitaTmp);
    }

    // Comprobamos si el solicitante se ha recibido por GET en la url principal

    if (
      !myGlobals.isNullUndefinedVacio(
        myGlobals.getSessionStore(myGlobals.eSessionStore.get_nif),
      )
    ) {
      this.oSolicitante.nif = myGlobals.getSessionStore(
        myGlobals.eSessionStore.get_nif,
      );
      this.oSolicitante.apellido1 = myGlobals.getSessionStore(
        myGlobals.eSessionStore.get_apellido1,
      );
      this.oSolicitante.apellido2 = myGlobals.getSessionStore(
        myGlobals.eSessionStore.get_apellido2,
      );
      this.oSolicitante.nombre = myGlobals.getSessionStore(
        myGlobals.eSessionStore.get_nombre,
      );
      this.oSolicitante.email = myGlobals.getSessionStore(
        myGlobals.eSessionStore.get_email,
      );
      this.oSolicitante.tlf1 = myGlobals.getSessionStore(
        myGlobals.eSessionStore.get_movil,
      );
      this.oSolicitante.asunto = myGlobals.getSessionStore(
        myGlobals.eSessionStore.get_asunto,
      );
    }

    // Cargamos todos los departamentos y áreas de atención al público

    this.CargarAreasPorDepartamento();

    this.onStepChange(this.oStepper);
  }

  // Evento cambio de área
  changeArea(index: number) {
    this.oTramiteActivo = null
    this.oAreaActiva = this.aDtosAreas[index];
    this.videollamada = false;

    // Comprobamos si el área permite seleccionar qué persona quieres que te atienda

    this.oPersonaAreaActiva = null;
    if (this.oAreaActiva.citapersonalizada) {
      this.aPersonaArea = this.oAreaActiva.PERSONAAREA;
    } else {
      this.aPersonaArea = null;
    }

    // Cargamos los trámites del área

    this.CargarTramitesArea();

    this.FormateaTextoInformativo(index);
    // this.CargarFechasLibresArea(true);
  }

  // Evento cambio de área
  changeTramite(index: number) {
    this.oTramiteActivo = this.aTramitesArea[index];
  }

  // Evento cambio de área
  changePersonaArea(index: number) {
    // El índice 0 es - Cualquiera -

    if (index === 0) {
      this.oPersonaAreaActiva = null;
    } else {
      this.oPersonaAreaActiva = this.aPersonaArea[index - 1];
    }
  }

  // Evento cambio de área
  changeAAAAMMCita(index: number) {
    this.iAnnioActivoCalendario = this.aAnnioMesCita[index].ANNIO;
    this.iMesActivoCalendario = this.aAnnioMesCita[index].MES;
    this.iDiaActivoCalendario = 0;
    this.oFechaCitaAreaActiva = null;

    // Creamos el calendario

    this.CrearCalendario();
  }

  // Evento de cambio de día de la cita
  changeDiaCita(sDia: string) {
    if (!sDia) return;

    const fechaSeleccionada =
      this.iAnnioActivoCalendario.toString().padStart(4, "0") +
      this.iMesActivoCalendario.toString().padStart(2, "0") +
      sDia.toString().padStart(2, "0");

    // Marcar el día activo en el calendario
    this.iDiaActivoCalendario = parseInt(sDia, 10);

    // Limpiar horario anterior
    this.oFechaCitaAreaActiva = null;
    this.iIndiceHorarioActivo = 0;

    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Cargando citas disponibles, espere ...",
      "",
    );

    this._ApiAppService
      .getCitasDisponiblesPorDia(fechaSeleccionada, {
        id_area: this.oAreaActiva.id_area,
        id_persona: this.oPersonaAreaActiva?.id_fk_persona || 0,
      })
      .subscribe({
        next: (respuesta) => {
          this.oFechaCitaAreaActiva = respuesta;
          myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
        },
        error: (error) => {
          console.error("Error al cargar horarios del día:", error);
        },
      });
  }

  // Evento cambio de hora
  changeHorario(index: number) {
    this.iIndiceHorarioActivo = index;
    return true;
  }

  changeRepresentado(index: number) {
    if (index === 0) {
      this.sFiltroRepresentadoNIF = "";
      this.BorrarRepresentado();
    }
    this.iIndiceRepresentado = index;
    this.representadook = false;
  }

  changeAceptaLosTerminos(): void {
    this.AceptaLosTerminos = !this.AceptaLosTerminos;
  }

  changeTipoNIF(tipo: string, index: number): void {
    if (!myGlobals.isNullUndefinedVacio(tipo)) {
      if (tipo === "S") {
        switch (index) {
          case 0:
            this.sTipoNIFsol = "N";
            break;
          case 1:
            this.sTipoNIFsol = "C";
            break;
          case 2:
            this.sTipoNIFsol = "E";
            break;
          case 3:
            this.sTipoNIFsol = "O";
            break;
        }
      } else {
        if (tipo === "R") {
          switch (index) {
            case 0:
              this.sTipoNIFrep = "N";
              break;
            case 1:
              this.sTipoNIFrep = "C";
              break;
            case 2:
              this.sTipoNIFrep = "E";
              break;
            case 3:
              this.sTipoNIFrep = "O";
              break;
          }
        }
      }
    }
  }

  onSubmitAreaAtencion() {
    if (
      !myGlobals.isNullUndefined(this.oAreaActiva) &&
      !myGlobals.isNullUndefined(this.oTramiteActivo)
    ) {
      return this.CargarFechasLibresArea(true);
    } else {
      return false;
    }
  }

  onSubmitSolicitante() {
    const existeCita = false;

    this.sAvisoErrorNIFSol = "Código identidad obligatorio;";

    // Validamos el resto del formulario
    if (this.myFormSolicitante.invalid) {
      return false;
    }

    // Validamos el código identidad
    if (!this.ValidarCodigo("S")) {
      return false;
    }

    // Validamos el email
    if (!this.ValidarEmail("S")) {
      return false;
    }

    // Si el representado no es nuevo, validamos si se ha introducido el nif del representado y se ha pulsado el botón buscar
    if (this.iIndiceRepresentado === 1) {
      if (this.sFiltroRepresentadoNIF !== "") {
        if (
          myGlobals.isNullUndefined(this.oRepresentado) ||
          myGlobals.isNullUndefinedVacio(this.oRepresentado.nif)
        ) {
          this.sAvisoErrorNIFRepBusqueda =
            "Pulse el botón buscar para comprobar que existe el representado";
          return false;
        }
      } else {
        this.sAvisoErrorNIFRepBusqueda =
          "No ha especificado el identificador del representado";
        return false;
      }
      if (this.oSolicitante.nif === this.oRepresentado.nif) {
        this.sAvisoErrorNIFRepBusqueda = "No puede representarse a sí mismo";
        return false;
      }
    }

    // Realizamos las conversiones correspondientes

    this.oSolicitante.nif = this.oSolicitante.nif.toUpperCase();
    this.oSolicitante.nombre = this.oSolicitante.nombre.toUpperCase();
    if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.apellido1)) {
      this.oSolicitante.apellido1 = this.oSolicitante.apellido1.toUpperCase();
    }
    if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.apellido2)) {
      this.oSolicitante.apellido2 = this.oSolicitante.apellido2.toUpperCase();
    }
    if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.email)) {
      this.oSolicitante.email = this.oSolicitante.email.toLowerCase();
    }

    this.oStepper.next();
    return true;
  }

  onSubmitRepresentado() {
    const existeCita = false;

    this.sAvisoErrorNIFRep = "Código identidad obligatorio;";

    // Validamos el resto del formulario
    if (this.myFormRepresentado.invalid) {
      return false;
    }

    if (this.hayRepresentado) {
      // Validamos el código identidad
      if (!this.ValidarCodigo("R")) {
        return false;
      }

      // Validamos el email
      if (!this.ValidarEmail("R")) {
        return false;
      }
    }

    // Realizamos las conversiones correspondientes

    this.oRepresentado.nif = this.oRepresentado.nif.toUpperCase();
    if (this.oRepresentado.nif === this.oSolicitante.nif) {
      this.sErrorNifIguales = "El solicitante no se puede representar a sí mismo"
      return false;
    }
    this.oRepresentado.nombre = this.oRepresentado.nombre.toUpperCase();
    if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.apellido1)) {
      this.oRepresentado.apellido1 = this.oRepresentado.apellido1.toUpperCase();
    }
    if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.apellido2)) {
      this.oRepresentado.apellido2 = this.oRepresentado.apellido2.toUpperCase();
    }
    if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.email)) {
      this.oRepresentado.email = this.oRepresentado.email.toLowerCase();
    }

    this.oStepper.next();
    return true;
  }

  // Valida si el email es correcto
  ValidarEmail(tipo: string): boolean {
    let resultado = true;
    if (tipo === "S") {
      if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.email)) {
        resultado = myGlobals.validarEmail(this.oSolicitante.email);
      }
    } else {
      if (tipo === "R") {
        if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.email)) {
          resultado = myGlobals.validarEmail(this.oRepresentado.email);
        }
      }
    }
    return resultado;
  }

  // Valida si es requerido el apellido1 del solicitante y representado o no
  // en el caso que sea una empresa cif
  Apellido1Requerido(tipo: string): boolean {
    if (tipo === "S") {
      return (
        myGlobals.isNullUndefinedVacio(this.oSolicitante.apellido1) &&
        this.sTipoNIFsol !== "C"
      );
    }
    if (tipo === "R") {
      return (
        myGlobals.isNullUndefinedVacio(this.oRepresentado.apellido1) &&
        this.sTipoNIFrep !== "C"
      );
    }
  }

  // Valida si el área y trámite se encuentran seleccionados
  AreaTramiteSeleccionado(): boolean {
    return (
      !myGlobals.isNullUndefined(this.oAreaActiva) &&
      !myGlobals.isNullUndefined(this.oTramiteActivo)
    );
  }

  BuscarRepresentado(): boolean {
    this.representadook = false;
    this.sAvisoErrorNIFRepBusqueda = "";
    if (myGlobals.isNullUndefinedVacio(this.sFiltroRepresentadoNIF)) {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.Advertencia,
        "",
        "El código de identidad del representante es obligatorio",
        "",
      );
      return false;
    }
    this.sFiltroRepresentadoNIF = this.sFiltroRepresentadoNIF.toUpperCase();
    if (this.sFiltroRepresentadoNIF === this.oSolicitante.nif) {
      myGlobals.Mensaje(myGlobals.eTipoMensaje.Advertencia,
        "",
        "Usted no se puede representar a sí mismo",
        "",
      );
      return false;
    } 

    this.oRepresentado = new cSolicitante();

    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Comprobando representado, espere ...",
      "",
    );

    // Comprobamos si existe el representado

    this._ApiAppService
      .ObtenerSolicitante(this.sFiltroRepresentadoNIF)
      .subscribe(
        (data) => {
          if (data != null) {
            this.oRepresentado = new cSolicitante();
            this.oRepresentado.AsignarInterface(data);
            this.representadook = true;
          }
        },
        (err) => {
          myGlobals.CapturaMensajeHTTP(err, true);
        },
      );

    myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");

    if (myGlobals.isNullUndefinedVacio(this.oRepresentado.nif)) {
      return false;
    } else {
      this.representadook = true;
      return true;
    }
  }

  // Bloqueamos la precita para que no se le asigne a otra persona que acceda al sistema
  BloquearPrecita(): boolean {
    let idPrecita = 0;
    let sHHMM = "";
    this.oPrecitaBloqueo = null;

    if (!myGlobals.isNullUndefined(this.oFechaCitaAreaActiva)) {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.BarraProgreso,
        "",
        "Bloqueando cita, espere ...",
        "",
      );

      idPrecita =
        this.oFechaCitaAreaActiva.HHMMLIBRES[this.iIndiceHorarioActivo]
          .id_pre_cita;
      sHHMM =
        this.oFechaCitaAreaActiva.HHMMLIBRES[
          this.iIndiceHorarioActivo
        ].HH.toString() +
        ":" +
        this.oFechaCitaAreaActiva.HHMMLIBRES[
          this.iIndiceHorarioActivo
        ].MM.toString();

      this._ApiAppService.BloquearPrecita(idPrecita, sHHMM).subscribe(
        (data) => {
          if (myGlobals.isNullUndefined(data)) {
            myGlobals.Mensaje(
              myGlobals.eTipoMensaje.Advertencia,
              "",
              "Cita no bloqueada",
              "",
            );
          } else {
            this.oPrecitaBloqueo = data;

            // Si todo ha ido correcto no permitimos editar los datos del área

            this.stepperActivarEdicionArea(false);
            this.stepperMover(2);

            myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
          }
        },
        (err) => {
          if (err.status === 400) {
            myGlobals.Mensaje(
              myGlobals.eTipoMensaje.Advertencia,
              "",
              "El horario seleccionado ya no se encuentra disponible, seleccione uno nuevo.",
              "",
            );
          } else {
            myGlobals.CapturaMensajeHTTP(err, true);
          }
        },
      );
    }
    return !myGlobals.isNullUndefined(this.oPrecitaBloqueo);
  }

  // Comprueba si no se ha podido bloquear la precita
  ErrorBloqueoPrecita(): boolean {
    if (myGlobals.isNullUndefined(this.oPrecitaBloqueo)) {
      this.stepperActivarEdicionArea(true); // Activamos la edición de los datos del área
      this.stepperMover(1); // Retrocedemos al panel donde se piden las fechas
      return false;
    } else {
      return true;
    }
  }

  // Desbloqueamos la precita para que se le pueda asignar a otra persona que acceda al sistema
  DesbloquearPrecita(): void {
    if (!myGlobals.isNullUndefined(this.oPrecitaBloqueo)) {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.BarraProgreso,
        "",
        "Desbloqueando cita, espere ...",
        "",
      );

      this._ApiAppService
        .DesbloquearPrecita(this.oPrecitaBloqueo.id_pre_cita_bloqueo)
        .subscribe(
          (data) => {
            if (myGlobals.isNullUndefined(data)) {
              myGlobals.Mensaje(
                myGlobals.eTipoMensaje.Advertencia,
                "",
                "Cita no desbloqueada",
                "",
              );
            } else {
              this.oPrecitaBloqueo = null;
              myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
            }
          },
          (err) => {
            myGlobals.CapturaMensajeHTTP(err, true);
          },
        );
    }
  }

  // Activa o desactiva el stepper de departamento / área
  stepperActivarEdicionArea(bEditable: boolean) {
    this.oStepper.steps.first.editable = bEditable;

    // Refrescamos los datos abreviados de la precita cuando esta se bloquea pa
    this.RefrescarCitaAbreviada();
  }
  // Desplazamiento entre stepper, tiene que permitir la edición
  stepperMover(index: number) {
    this.oStepper.selectedIndex = index;
    this.onStepChange(this.oStepper);
  }

  // Evento de cambio de step
  public onStepChange(stepper: MatStepper) {
    if (!myGlobals.isNullUndefined(stepper)) {
      this.EnviarFocoStep(stepper.selectedIndex);
    }
  }

  // Envía el foco al inicio del step correspondiente
  public EnviarFocoStep(index: number) {
    switch (index) {
      case 0:
        this.ScrollTo(0);
        break;
      case 1:
        this.ScrollTo(100);
        break;
      case 2:
        this.ScrollTo(200);
        break;
      case 3:
        if (this.hayRepresentado && this.iIndiceRepresentado === 0) {
          this.ScrollTo(300);
        } else {
          this.ScrollTo(400);
        }
        break;
      case 4:
        this.ScrollTo(400);
        break;
    }
  }

  // Hace scroll a una altura indicada
  public ScrollTo(px: number) {
    if (window.innerWidth < 1025) {
      // Para movil y tablet
      $("html,body").animate({ scrollTop: px }, "slow");
    } else {
      // Para escritorio
      $(".capa-home").animate({ scrollTop: px }, "slow");
    }
  }

  // Cargamos todos los departamentos y sus áreas correspondientes
  CargarAreasPorDepartamento(): void {
    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Cargando áreas, espere ...",
      "",
    );

    // Comprobamos si existe el solicitante y además tiene citas pendientes
    this._ApiAppService.ObtenerAreasPersonalPorDepartamento().subscribe(
      (data) => {
        if (myGlobals.isNullUndefined(data) || data.length === 0) {
          myGlobals.Mensaje(
            myGlobals.eTipoMensaje.Advertencia,
            "",
            "No hay definida ninguna área en el cliente.",
            "",
          );
        } else {
          // Si la llamada ser realiza directamente desde la solicitud de cita
          // Cargamos todas las áreas, en caso contrario, si la llamada se realiza
          // de la consulta de departamentos o trámites sólo cargamos el área seleccionada

          if (this.citatemporal.id_area === 0) {
            this.aDtosAreas = data;
          } else {
            this.aDtosAreas = [];
            for (let i = 0; i <= data.length - 1; i++) {
              if (parseInt(data[i].id_area) === this.citatemporal.id_area) {
                this.aDtosAreas.push(data[i]);
                break;
              }
            }
          }
          this.oAreaActiva = this.aDtosAreas[0];

          // Comprobamos si el área permite seleccionar qué persona quieres que te atienda

          this.oPersonaAreaActiva = null;
          if (!myGlobals.isNullUndefined(this.oAreaActiva)) {
            if (this.oAreaActiva.citapersonalizada) {
              this.aPersonaArea = this.oAreaActiva.PERSONAAREA;
            } else {
              this.aPersonaArea = null;
            }
          }

          this.FormateaTextoInformativo(0);

          // Cargamos los trámites del área activa

          this.CargarTramitesArea();

          // // Precargamos las fechas libres de la primera área

          // this.CargarFechasLibresArea(true);

          myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
        }
      },
      (err) => {
        myGlobals.CapturaMensajeHTTP(err, true);
      },
    );
  }

  // Carga de los trámites y documentos del área activa
  CargarTramitesArea(): void {
    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Cargando trámites, espere ...",
      "",
    );

    // Comprobamos si existe el solicitante y además tiene citas pendientes

    this._ApiAppService
      .ObtenerTodosLosDocumentosTramite(this.oAreaActiva.id_area)
      .subscribe(
        (data) => {
          if (myGlobals.isNullUndefined(data) || data.length === 0) {
            myGlobals.Mensaje(
              myGlobals.eTipoMensaje.Advertencia,
              "",
              "No hay definido ningún trámite en el cliente.",
              "",
            );
            this.oTramiteActivo = null;
            this.aTramitesArea = null;
          } else {
            // Si la llamada ser realiza directamente desde la solicitud de cita
            // cargamos todas los trámites, en caso contrario, si la llamada se realiza
            // de la consulta de departamentos o trámites sólo cargamos el trámite seleccionado

            if (this.citatemporal.id_tramite === 0) {
              // Convertimos la coleccion de objetos interface a array de clases
              this.aTramitesArea = Tramites.convertirAClase(
                data,
                this.oAreaActiva.id_area,
              );
            } else {
              this.aTramitesArea = [];
              for (let i = 0; i <= data.length - 1; i++) {
                if (parseInt(data[i].id_tramite) === this.citatemporal.id_tramite) {
                  this.aTramitesArea = Tramites.convertirAClase(
                    new Array(data[i]),
                    this.oAreaActiva.id_area,
                  );
                  break;
                }
              }
            }

            this.oTramiteActivo = this.aTramitesArea[0];
          }
          myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
        },
        (err) => {
          myGlobals.CapturaMensajeHTTP(err, true);
        },
      );
  }

  // Muestra la información del área seleccionado
  private FormateaTextoInformativo(index: number): void {
    this.sInfoArea = "";
    this.sInfoAreaCarencia = "";

    if (
      !myGlobals.isNullUndefined(this.aDtosAreas) &&
      this.aDtosAreas.length > 0
    ) {
      if (!myGlobals.isNullUndefined(this.aDtosAreas[index].txtinfoweb)) {
        this.sInfoArea = this.aDtosAreas[index].txtinfoweb;
      }
      this.sInfoAreaCarencia =
        "Periodo carencia " +
        this.aDtosAreas[index].minutos5xcita * 5 +
        " minutos.";
    }
  }

  // Cargamos las fechas y horas libres del área seleccionada
  CargarFechasLibresArea(CargaInicial: boolean): void {
    let iUltimaHHLibre: number;
    let iUltimaMMLibre: number;
    let idPersona = 0;
    const f: Date = new Date();

    this.HayCitasLibresArea = false;

    if (CargaInicial) {
      iUltimaHHLibre = 0;
      iUltimaMMLibre = 0;
    }

    this.aFechasCitaArea = null;

    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Cargando citas libres, espere ...",
      "",
    );

    this.aFechasCitaArea = null;
    if (!myGlobals.isNullUndefined(this.oPersonaAreaActiva)) {
      idPersona = this.oPersonaAreaActiva.id_fk_persona;
    }
      
    // 1. Creamos una copia exacta de 'f' y le sumamos un día usando las reglas de fechas de JS
    const fechaSiguiente = new Date(f);
    fechaSiguiente.setDate(fechaSiguiente.getDate() + 1);

    // 2. Extraemos los datos de la nueva fecha (que ya gestionó sola el cambio de mes/año)
    const fechaIni: string =
      fechaSiguiente.getFullYear().toString() +
      (fechaSiguiente.getMonth() + 1).toString().padStart(2, "0") +
      fechaSiguiente.getDate().toString().padStart(2, "0");

    this._ApiAppService
      .ObtenerDiasDisponibles(
        this.oAreaActiva.id_area,
        idPersona || 0,
        Number(fechaIni),
        f.getHours(),
        f.getMinutes(),
      )
      .pipe(
        tap((data) => {
          this.aFechasCitaDisponibles = data;
        }),
        // Encadenamos la segunda llamada
        switchMap((data) => {
          // Usamos 'fechaSiguiente' que ya tiene el día sumado, en lugar de mutar 'f'
          const iUltimaFCLibre: number = data.length > 0 
            ? Math.min(...data) 
            : myGlobals.fechaDatetoAAAAMMDD(fechaSiguiente);

          return this._ApiAppService.getCitasDisponiblesPorDia(
            iUltimaFCLibre.toString(),
            {
              id_area: this.oAreaActiva.id_area,
              id_persona: idPersona || 0,
            },
          );
        })
      )
      .subscribe(
        (data) => {
          if (data != null) {
            if (!myGlobals.isNullUndefined(data) && data.HHMMLIBRES.length > 0) {
              this.oFechaCitaAreaActiva = data;
              this.iIndiceHorarioActivo = 0;
              this.iAnnioActivoCalendario = parseInt(data.fecha.toString().substring(0, 4));
              this.iMesActivoCalendario = parseInt(data.fecha.toString().substring(4, 6));
              this.iDiaActivoCalendario = parseInt(data.fecha.toString().substring(6, 8));
            
              this.iFechaMaximaCita = myGlobals.fechaDatetoAAAAMMDD(
                myGlobals.fechaSumaRestaDias(f, this.oAreaActiva.citaantelacion),
              );
            
              this.HayCitasLibresArea = true;
              this.CalcularMesesCita();
              this.iIndiceAnnioMesActivo = this.aAnnioMesCita.findIndex(
                  am => am.ANNIO === this.iAnnioActivoCalendario && am.MES === this.iMesActivoCalendario
                );
                if (this.iIndiceAnnioMesActivo === -1) {
                  this.iIndiceAnnioMesActivo = 0; // Fallback por seguridad
              }
              this.CrearCalendario();
            
              myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
            } else {
              myGlobals.Mensaje(
                myGlobals.eTipoMensaje.Advertencia,
                "Sin citas disponibles",
                "No quedan citas libres para este área de atención.",
                "De acuerdo"
              );
            }
          } else {
            myGlobals.Mensaje(
              myGlobals.eTipoMensaje.Error,
              "Error",
              "La consulta ha fallado, por favor inténtelo de nuevo",
              "De acuerdo"
            );
          }
        },
        (err) => {
          myGlobals.CapturaMensajeHTTP(err, true);
        }
      );


    if (!CargaInicial) {
      this.onStepChange(this.oStepper);
    }
  }

  EsDiaFuturoValido(sDia: string): boolean {
    if (sDia === "") return false;

    const fechaActual =
      this.iAnnioActivoCalendario.toString() +
      this.iMesActivoCalendario.toString().padStart(2, "0") +
      sDia.padStart(2, "0");
    const dia = Number(sDia);

    const hoy = new Date();
    const fechaMinima = new Date(hoy);

    const fechaMaxima = new Date(hoy);
    if (
      !myGlobals.isNullUndefined(this.oAreaActiva) &&
      this.oAreaActiva.citaantelacion > 0
    ) {
      fechaMaxima.setDate(hoy.getDate() + this.oAreaActiva.citaantelacion);
    } else {
      // Por seguridad, si no hay citaantelacion, asumimos 0 días -> no se puede pedir cita
      return false;
    }

    // La fecha a validar
    const fechaCalendario = new Date(
      this.iAnnioActivoCalendario,
      this.iMesActivoCalendario - 1,
      dia,
    );

    // Validación del rango de fechas
    const enRango =
      fechaCalendario > fechaMinima && fechaCalendario <= fechaMaxima;
    if (!enRango) return false;

    // Validación de sábado y domingo
    const diaSemana = fechaCalendario.getDay(); // 0 = domingo, 6 = sábado
    const configCliente = myGlobals.oClienteActivo().clienteConfig;

    if (
      (diaSemana === 0 && !configCliente.citas_domingo) ||
      (diaSemana === 6 && !configCliente.citas_sabado)
    ) {
      return false;
    }

    if (!this.aFechasCitaDisponibles.includes(Number(fechaActual))) {
      return false;
    }

    // Validaciones completadas correctamente
    return true;
  }

  // Valida si el código de identidad es correcto
  ValidarCodigo(sOrigen: string): boolean {
    let oValidacion: myGlobals.IValidaIdentificador;
    let sTipoCodigo = "";
    let sTipoCodigoAux = "";
    let sCodigo = "";

    if (sOrigen === "S") {
      sTipoCodigo = this.sTipoNIFsol;
      sCodigo = this.oSolicitante.nif.toUpperCase();
    } else {
      if (sOrigen === "R") {
        sTipoCodigo = this.sTipoNIFrep;
        sCodigo = this.oRepresentado.nif.toUpperCase();
      }
    }

    if (sTipoCodigo === "O") {
      return true;
    } else {
      switch (sTipoCodigo) {
        case "N":
          sTipoCodigoAux = "nif";
          break;
        case "C":
          sTipoCodigoAux = "cif";
          break;
        case "E":
          sTipoCodigoAux = "NIE";
          break;
      }
      oValidacion = myGlobals.ValidaNIFCIFNIE(sTipoCodigoAux, sCodigo);
    }
    if (!oValidacion.valido) {
      if (sOrigen === "S") {
        this.sAvisoErrorNIFSol = oValidacion.aviso;
      } else {
        if (sOrigen === "R") {
          this.sAvisoErrorNIFRep = oValidacion.aviso;
        }
      }
      return false;
    } else {
      return true;
    }
  }

  // Crea el calendario del mes y año activo
  public CrearCalendario(): void {
    let iDiaMes = 0;
    let iDiaMesAnt = 0;
    let iDiaMesPos = 0;
    var iDiaSemanaDia1MesActivo: number = new Date(
      this.iAnnioActivoCalendario.toString() +
        "/" +
        this.iMesActivoCalendario.toString() +
        "/1",
    ).getDay();
    // var iDiaSemanaDia1MesActivo: number = myGlobals.fechaDiaSemana06(new Date(this.iAnnioActivoCalendario.toString() + '/' + this.iMesActivoCalendario.toString() + '/1'));
    var iDiaSemanaDia1MesActivo: number = myGlobals.fechaDiaSemana17(
      new Date(
        this.iAnnioActivoCalendario.toString() +
          "/" +
          this.iMesActivoCalendario.toString() +
          "/1",
      ),
    );
    var iAñoAnt = 0;
    var iMesAnt = 0;
    var iAñoPos = 0;
    var iMesPos: number;

    try {
      // Inicializamos el calendario mensual

      this.aCalendario = new Array(6).fill("").map(() => new Array(7).fill(""));

      // El domingo en la enumeración se trata como 1 y nosotros necesitamos tratarlo como 6

      // la función getDay() devuelve 0 para el domingo, 1 lunes, etc.
      if (iDiaSemanaDia1MesActivo === 0) {
        iDiaSemanaDia1MesActivo = 7;
      }

      // Calculamos el més/año anterior y posterior

      var iAñoAnt = this.iAnnioActivoCalendario - 1;
      var iMesAnt = this.iMesActivoCalendario - 1;
      var iAñoPos = this.iAnnioActivoCalendario + 1;
      var iMesPos = this.iMesActivoCalendario + 1;

      switch (this.iMesActivoCalendario) {
        case 1: {
          iMesAnt = 12;
          break;
        }
        case 12: {
          iMesPos = 1;
          break;
        }
        default: {
          break;
        }
      }

      iDiaMesAnt = myGlobals.fechaDiasTotalesMes(iAñoAnt, iMesAnt);

      // Si el día 1 del mes actual no cae en lunes calcumamos el nº de días del mes anterior que mostraremos en el calendario

      if (iDiaSemanaDia1MesActivo >= 1) {
        iDiaMesAnt -= iDiaSemanaDia1MesActivo - 1;
      }

      for (let iFil = 0; iFil <= 6; iFil++) {
        for (let iCol = 0; iCol <= 6; iCol++) {
          iDiaMesAnt++;
          // Creamos los días del mes anterior
          if (iDiaMesAnt <= myGlobals.fechaDiasTotalesMes(iAñoAnt, iMesAnt)) {
            this.aCalendario[iFil][iCol] = ""; //iDiaMesAnt.toString();
          } else {
            iDiaMes++;
            // Creamos los días del mes actual
            if (
              iDiaMes <=
              myGlobals.fechaDiasTotalesMes(
                this.iAnnioActivoCalendario,
                this.iMesActivoCalendario,
              )
            ) {
              this.aCalendario[iFil][iCol] = iDiaMes.toString();
            } else {
              iDiaMesPos++;
              if (
                iDiaMesPos <= myGlobals.fechaDiasTotalesMes(iAñoPos, iMesPos)
              ) {
                this.aCalendario[iFil][iCol] = ""; //iDiaMesPos.toString();
              }
            }
          }
        }
      }
    } catch (error) {}
  }

  // Comprueba si el día del calendario se corresponde con el día actual (today)
  DiaCitaToday(sDia: string): boolean {
    let sFecha = "";
    const ftoday: Date = new Date();
    let sToday = "";
    if (sDia !== "") {
      sFecha =
        this.iAnnioActivoCalendario.toString().padStart(4, "0") +
        this.iMesActivoCalendario.toString().padStart(2, "0") +
        sDia.toString().padStart(2, "0");
      sToday = myGlobals.fechaDatetoAAAAMMDD(ftoday).toString();
      return sFecha === sToday;
    }
    return false;
  }

  // Valida si el día del calendario es un día de cita
  // 0 - fecha no válida, 1 = fecha válida y activa, 2 = fecha válida
  DiaCitaValido(sDia: string): number {
    let iFecha: number;
    let iFechaActiva: number;

    if (
      !myGlobals.isNullUndefined(this.oFechaCitaAreaActiva) &&
      this.oFechaCitaAreaActiva.HHMMLIBRES.length > 0
    ) {
      if (sDia !== "") {
        iFecha = parseInt(
          this.iAnnioActivoCalendario.toString().padStart(4, "0") +
            this.iMesActivoCalendario.toString().padStart(2, "0") +
            sDia.toString().padStart(2, "0"),
        );
        iFechaActiva = parseInt(
          this.iAnnioActivoCalendario.toString().padStart(4, "0") +
            this.iMesActivoCalendario.toString().padStart(2, "0") +
            this.iDiaActivoCalendario.toString().padStart(2, "0"),
        );
        if (
          this.oFechaCitaAreaActiva.fecha === iFecha &&
          iFecha <= this.iFechaMaximaCita
        ) {
          if (iFecha === iFechaActiva) {
            return 1;
          } else {
            return 2;
          }
        }
      }
    }
    return 0;
  }

  // Calcula el rango de meses que se puede pedir cita
  // cada vez que se llama al servicio, que pueden estar contenidas en el mismo mes o
  // meses distintos.
  // Se calcula cada vez que se cambia de área de atención
  CalcularMesesCita(): void {
    this.aAnnioMesCita = [];

    if (
      !myGlobals.isNullUndefined(this.oAreaActiva) &&
      this.oAreaActiva.citaantelacion > 0
    ) {
      const hoy = new Date();
      const fechaInicio = new Date(hoy);
      fechaInicio.setDate(hoy.getDate() + 1); // Citas desde mañana

      const fechaFin = new Date(hoy);
      fechaFin.setDate(hoy.getDate() + this.oAreaActiva.citaantelacion); // Hasta citaantelacion días

      let annioActual = fechaInicio.getFullYear();
      let mesActual = fechaInicio.getMonth(); // 0-based (enero = 0)

      while (
        annioActual < fechaFin.getFullYear() ||
        (annioActual === fechaFin.getFullYear() &&
          mesActual <= fechaFin.getMonth())
      ) {
        this.aAnnioMesCita.push({
          ANNIO: annioActual,
          MES: mesActual + 1, // Convertimos a 1-based
        });

        // Incrementamos al siguiente mes
        mesActual++;
        if (mesActual > 11) {
          mesActual = 0;
          annioActual++;
        }
      }
    }
  }

  // Comprueba si el área permite personalizar citas
  AreaCitaPersonalizada(): boolean {
    return (
      !myGlobals.isNullUndefined(this.oAreaActiva) &&
      this.oAreaActiva.citapersonalizada &&
      this.oAreaActiva.PERSONAAREA.length > 0
    );
  }

  // Información de la cita que se muestra en el resumen final
  CargarResumenCita(): boolean {
    // Inicializamos el detalle de la cita y la volvemos a cargar
    this.oDetalleCita = new Cita.cDetalleCita();
    this.sEnRepresentacionDe = "";

    if (!myGlobals.isNullUndefined(this.oAreaActiva)) {
      // Información del área de atención y trámite a gestionar

      this.oDetalleCita.AREA =
        this.oAreaActiva.DEPARTAMENTO + " - " + this.oAreaActiva.AREA;

      if (
        !myGlobals.isNullUndefined(this.oPersonaAreaActiva) &&
        this.oPersonaAreaActiva.id_fk_persona > 0
      ) {
        this.oDetalleCita.AREA =
          this.oDetalleCita.AREA +
          ", ha solicitado que le atienda " +
          this.oPersonaAreaActiva.PERSONA;
      }

      // Información del trámite a gestionar

      if (!myGlobals.isNullUndefined(this.oTramiteActivo)) {
        this.oDetalleCita.TRAMITE = this.oTramiteActivo.TRAMITE;
        this.oDetalleCita.DOCUMENTACION = [];
        for (const oDocumento of this.oTramiteActivo.DOCUMENTOS) {
          this.oDetalleCita.DOCUMENTACION.push(oDocumento.INFO());
        }
      }

      // Información de la fecha y hora de la cita

      if (
        !myGlobals.isNullUndefined(this.oFechaCitaAreaActiva) &&
        this.oFechaCitaAreaActiva.HHMMLIBRES.length > 0 &&
        this.iDiaActivoCalendario >= 0
      ) {
        const f: Date = new Date(
          this.iAnnioActivoCalendario,
          this.iMesActivoCalendario - 1,
          this.iDiaActivoCalendario,
        );
        const iDiaSemana: number = myGlobals.fechaDiaSemana06(f);
        this.oDetalleCita.FECHA_HORA_CITA =
          myGlobals.aDiaSemana[iDiaSemana].toLowerCase() +
          ", " +
          this.iDiaActivoCalendario.toString() +
          " de " +
          myGlobals.aMes[this.iMesActivoCalendario - 1] +
          " del " +
          this.iAnnioActivoCalendario.toString() +
          " a las " +
          this.oFechaCitaAreaActiva.HHMMLIBRES[
            this.iIndiceHorarioActivo
          ].HH.toString().padStart(2, "0") +
          ":" +
          this.oFechaCitaAreaActiva.HHMMLIBRES[
            this.iIndiceHorarioActivo
          ].MM.toString().padStart(2, "0");
      }

      // Cargamos la información adicional

      this.oDetalleCita.SOLICITANTE_NIF = this.oSolicitante.nif;
      if (this.sTipoNIFsol != "C")
        this.oDetalleCita.SOLICITANTE =
          this.oSolicitante.nombre + " " + this.oSolicitante.apellido1;
      else this.oDetalleCita.SOLICITANTE = this.oSolicitante.nombre;
      if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.apellido2)) {
        this.oDetalleCita.SOLICITANTE =
          this.oDetalleCita.SOLICITANTE + " " + this.oSolicitante.apellido2;
      }
      this.oDetalleCita.SOLICITANTE_TLF1 = this.oSolicitante.tlf1;
      if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.tlf2)) {
        this.oDetalleCita.SOLICITANTE_TLF2 = this.oDetalleCita.SOLICITANTE_TLF2;
      }
      this.oDetalleCita.SOLICITANTE_EMAIL = this.oSolicitante.email;
      if (!myGlobals.isNullUndefined(this.oSolicitante.asunto)) {
        this.oDetalleCita.MOTIVO_CITA = this.oSolicitante.asunto;
      }

      // Información del representado

      if (
        this.hayRepresentado &&
        !myGlobals.isNullUndefinedVacio(this.oRepresentado.nif)
      ) {
        this.oDetalleCita.REPRESENTADO_NIF = this.oRepresentado.nif;
        this.oDetalleCita.REPRESENTADO_EMAIL = this.oRepresentado.email;

        this.sEnRepresentacionDe = this.oRepresentado.nombre;
        if (this.sTipoNIFrep != "C") {
          if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.apellido1)) {
            this.sEnRepresentacionDe += " " + this.oRepresentado.apellido1;
          }
          if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.apellido2)) {
            this.sEnRepresentacionDe += " " + this.oRepresentado.apellido2;
          }
        }
      }
      return true;
    }
    return false;
  }

  // Resumen abreviado de la cita, se lanza al pulsar el
  // botón siguiente del stepper de fecha y hora de la cita

  RefrescarCitaAbreviada(): void {
    this.oCitaAbreviada = new cCitaAbreviada();
    if (!myGlobals.isNullUndefined(this.oAreaActiva)) {
      this.oCitaAbreviada.area = this.oAreaActiva.AREA;
    }
    if (!myGlobals.isNullUndefined(this.oFechaCitaAreaActiva)) {
      this.oCitaAbreviada.fecha = myGlobals.fechaDateATexto(
        myGlobals.fechaAAAAMMDDtoDate(
          this.oFechaCitaAreaActiva.fecha.toString(),
        ),
        true,
      );

      this.oCitaAbreviada.hora =
        this.oFechaCitaAreaActiva.HHMMLIBRES[
          this.iIndiceHorarioActivo
        ].HH.toString().padStart(2, "0") +
        ":" +
        this.oFechaCitaAreaActiva.HHMMLIBRES[
          this.iIndiceHorarioActivo
        ].MM.toString().padStart(2, "0");
    }
    if (!myGlobals.isNullUndefined(this.oTramiteActivo)) {
      this.oCitaAbreviada.tramite = this.oTramiteActivo.TRAMITE;
    }
  }

  Mes(index: number): string {
    return myGlobals.aMes[index - 1];
  }
  DiasSemana(): string[] {
    return myGlobals.aDiaSemana;
  }

  // Cancelación de la cita
  CancelarCita(): void {
    // Desbloqueamos la cita si está se encontraba bloqueada

    this.DesbloquearPrecita();

    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.OperacionNoOk,
      "",
      "Cita cancelada por el solicitante.",
      "",
    );

    // Borramos la variable de sesión temporal que se utiliza desde la llamada
    // de áreas y trámites para pedir cita sin pasar por el menú principal
    myGlobals.eliminarSessionStore(myGlobals.eSessionStore.citatemporal);

    this.oRouter.navigateByUrl("/");
  }

  // Se confirma la cita
  ConfirmarCita(): void {
    if (this.isConfirming) return;
    this.isConfirming = true;
    myGlobals.Mensaje(
        myGlobals.eTipoMensaje.BarraProgreso,
        "",
        "Se está procesando su cita, espere ...",
        "",
      );

    // Composición inicial del objeto de cita
    const citaData: any = {
      id_pre_cita_bloqueo: this.oPrecitaBloqueo.id_pre_cita_bloqueo,
      id_fk_tramite: this.oTramiteActivo.id_tramite,
      tiponif: this.sTipoNIFsol,
      nif: this.oSolicitante.nif,
      nombre: this.oSolicitante.nombre,
      email: this.oSolicitante.email,
      tlf1: this.oSolicitante.tlf1,
      motivo: this.oSolicitante.asunto,
      personalizada:
        !myGlobals.isNullUndefined(this.oPersonaAreaActiva) &&
        this.oPersonaAreaActiva.id_fk_persona > 0,
    };

    if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.apellido1))
      citaData.apellido1 = this.oSolicitante.apellido1;
    if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.apellido2))
      citaData.apellido2 = this.oSolicitante.apellido2;
    if (!myGlobals.isNullUndefinedVacio(this.oSolicitante.tlf2))
      citaData.tlf2 = this.oSolicitante.tlf2;

    // Representado
    if (
      this.hayRepresentado &&
      !myGlobals.isNullUndefined(this.oRepresentado)
    ) {
      this.oRepresentado.tiponif = this.sTipoNIFrep;
      if (myGlobals.isNullUndefined(this.oRepresentado.id_solicitante)) {
        this.oRepresentado.id_solicitante = 0;
      }

      citaData.ID_REPRESENTADO = this.oRepresentado.id_solicitante;
      citaData.TIPONIF_REP = this.sTipoNIFrep;
      citaData.NIF_REP = this.oRepresentado.nif;
      citaData.NOMBRE_REP = this.oRepresentado.nombre;
      if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.apellido1))
        citaData.APELLIDO1_REP = this.oRepresentado.apellido1;
      if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.apellido2))
        citaData.APELLIDO2_REP = this.oRepresentado.apellido2;
      citaData.EMAIL_REP = this.oRepresentado.email;
      citaData.TLF1_REP = this.oRepresentado.tlf1;
      if (!myGlobals.isNullUndefinedVacio(this.oRepresentado.tlf2))
        citaData.TLF2_REP = this.oRepresentado.tlf2;
    }

    // Observable para crear la cita (después de gestionar la videollamada si aplica)
    let citaObservable: Observable<any>;

    if (this.videollamada && this.videollamadaClienteEnabled) {
      citaObservable = this._AtmConnectService
        .SolicitarVideollamada(
          this.oTramiteActivo.TRAMITE,
          this.oSolicitante.nif,
          this.oSolicitante.email,
          myGlobals
            .fechaAAAAMMDDtoDD_MM_AAAA(
              this.oFechaCitaAreaActiva.fecha.toString(),
            )
            .replace(/-/g, "/") +
            " " +
            this.oCitaAbreviada.hora,
          this.oAreaActiva.minutos5xcita,
        )
        .pipe(
          switchMap((res) => {
            citaData.telematica = true;
            citaData.id_video = res.id;
            citaData.url_video_personal = `${res.url_atm}&sudopw=${res.sudopw}`;
            citaData.url_video_solicitante = res.url_atm;

            const sCita = JSON.stringify(citaData);
            return this._ApiAppService.CrearCita(sCita);
          }),
        );
    } else {
      citaData.telematica = false;
      const sCita = JSON.stringify(citaData);
      citaObservable = this._ApiAppService.CrearCita(sCita);
    }

    // Ejecutamos el observable
    citaObservable.subscribe({
      next: (data) => {
        if (data != null) {
          const oResultadoCita = data;

          this.oDetalleCita.id_cita = oResultadoCita.id_cita;
          this.oDetalleCita.ticket = oResultadoCita.ticket;

          this.SetCitaCalendario();
          myGlobals.setSessionStore(
            myGlobals.eSessionStore.osolicitante,
            JSON.stringify(this.oSolicitante),
          );
          this.CitaConfirmada = true;
          this.oStepper.reset();
          myGlobals.eliminarSessionStore(myGlobals.eSessionStore.citatemporal);
          setTimeout(() => addeventatc.refresh(), 1000);
          myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
        } else {
          myGlobals.Mensaje(
          myGlobals.eTipoMensaje.Advertencia,
          "",
          "Se ha producido un error inesperado.",
          "",
          );
        }
      },
      error: (err) => {
        this.isConfirming = false;
        myGlobals.CapturaMensajeHTTP(err, true);
      },
    });
  }

  BorrarRepresentado() {
    this.representadook = false;
    this.sFiltroRepresentadoNIF = "";
    this.oRepresentado = new Solicitante.cSolicitante();
  }

  // // Grabación de una nueva cita
  // NuevaCita(): void {
  //   this.AceptaLosTerminos = false;
  //   this.CitaConfirmada = false;
  // }

  // Impresion de la cita en formato HTML
  ImprimirCita(): void {
    if (!myGlobals.isNullUndefined(this.oDetalleCita)) {
      Cita.ImprimirCitaHTML(
        myGlobals.getNombreCliente(),
        this.oDetalleCita,
        this.sEnRepresentacionDe,
      );
    } else {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.Advertencia,
        "",
        "No hay ninguna cita seleccionada.",
        "",
      );
    }
  }

  // Contruye los datos de la cita para el botón de añadir al calendario
  SetCitaCalendario(): void {
    this.oCitaCalendario = new Cita.cCitaCalendario();

    const cliente = myGlobals.getInfoCliente();

    const nHora = Number(this.oCitaAbreviada.hora.substr(0, 2));
    const nMinuto = Number(this.oCitaAbreviada.hora.substr(3, 5));
    const fecha: Date = new Date(
      this.iAnnioActivoCalendario,
      this.iMesActivoCalendario - 1,
      this.iDiaActivoCalendario,
      nHora,
      nMinuto,
    );

    // Fecha de inicio
    this.oCitaCalendario.FECHA_INICIO = fecha.toLocaleString();

    // Sumo una hora a la fecha
    fecha.setTime(fecha.getTime() + 1 * 60 * 60 * 1000);

    // Fecha fin
    this.oCitaCalendario.FECHA_FIN = fecha.toLocaleString();

    // Titulo
    this.oCitaCalendario.TITULO = "Cita " + this.oDetalleCita.ticket;

    // Descripción
    this.oCitaCalendario.DESCRIPCION =
      "Dispone de una cita en " +
      cliente.client.nombre +
      " para el área de " +
      this.oDetalleCita.AREA +
      ".";

    // Dirección
    this.oCitaCalendario.direccion = cliente.client.Direccion;

    // Zona horaria
    this.oCitaCalendario.TIMEZONE = "Europe/Paris";
  }

  AbrirEnlace(tipo: number): void {
    const cliente = myGlobals.getInfoCliente();

    if (tipo === 1) {
      // Términos y Condiciones
      console.log(cliente);
      this.AbrirUrlExterna(`${environment.backends.URL_API_ROOT}/Recursos/${myGlobals.IdClienteActivo()}/27/documentos/${cliente.clienteConfig.terminos_condiciones}`);
    } else if (tipo == 2) {
      // Política de privacidad
      this.AbrirUrlExterna(`${environment.backends.URL_API_ROOT}/Recursos/${myGlobals.IdClienteActivo()}/27/documentos/${cliente.clienteConfig.privacidad}`);
    }
  }

  AbrirUrlExterna(sUrl: string, sTarget = "_blank"): boolean {
    if (this.validarUrlExterna(sUrl)) {
      const link = document.createElement("a");
      link.target = sTarget;
      link.href = sUrl;
      link.setAttribute("visibility", "hidden");
      link.click();
      return true;
    } else {
      return false;
    }
  }

  validarUrlExterna(sUrl: string): boolean {
    return /^http[s]?:\/\//.test(sUrl.toLowerCase());
  }

  hayRepresentadoChanged(valor: boolean) {
    if (!valor) {
      this.iIndiceRepresentado = 0;
      this.sFiltroRepresentadoNIF = '';
      this.representadook = false;
      this.sAvisoErrorNIFRepBusqueda = '';
    }
  }
}
